import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=1ec8cfd4&scoped=true&"
import script from "./ViewOrder.vue?vue&type=script&lang=js&"
export * from "./ViewOrder.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/form.css?vue&type=style&index=0&id=1ec8cfd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec8cfd4",
  null
  
)

export default component.exports